export enum SelectionMode {
    Single,
    Many,
    None
}